<template>
  <div class="content-detail-container">
    <div
      v-if="content"
      class="col-md-12 col-sm-12 col-lg-12 col-xlg-12 poster-container"
      style="padding:0;"
    >
      <img width="100%" height="100%" :src="getPoster(content,'LANDSCAPE')" />
    </div>
    <!-- <div class=" col-md-12 col-sm-12 col-lg-12 gradient-container"></div> -->
    <div v-if="content" class="col-md-12 col-sm-12 col-lg-12 col-xlg-12 content-container">
      <h2>{{content.title}}</h2>
      <div class="card-detail-progress" v-if="progress">
        <div
          class="progress-percent"
          :id="`progress-${content.contentid}`"
          :style="{ width: progress + '%' }"
        ></div>
      </div>
      <div class="content-tags">
        <p>{{content.category}}</p>
        <p>{{content.year}}</p>
      </div>
      <div class="languages" style="margin-top: 5px;">
        <p
          v-for="(lang,index) in languages"
          :key="lang"
          :style="(index != 0) ? 'padding-left: 10px;border-left:1.5px solid rgba(255, 252, 252, 0.76);margin-right:10px;': 'margin-right:10px;'"
        >{{lang}}</p>
      </div>
      <!-- Book Button -->
      <div class="card-book-btn">
        <Loading v-show="showLoadingForButton"></Loading>
        <button v-if="buttonTitle"
          class="btn-lg-primary"
          ref="bookNowBtn"
          @click="routeCard(content)"
        >
        {{buttonTitle}}
        </button>
      </div>
      <!-- Content Crew -->
      <div v-for="(castandcrew, index) in getCrew()" :key="index">
        <p class="starring">{{castandcrew.role}} :</p>
        <p class="castncrew">{{ castandcrew.names }}</p>
      </div>
      <p class="content-description">{{content.description}}</p>
      <div class="detail-card-ioncs row">
        <div class="col-xlg-2 col-lg-2 col-md-2 col-sm-3 buttonHover">
          <div class="trailer-btn">
            <!--Remove inline styles when you uncomment like and dislike-->
            <button type="button" class="watchlist-btn" @click="watchTrailer" style="background: white;border: none;">
              <img src="@/assets/icons/Ic_trailer_black.svg" alt="watchlist" />
              <p class="like-tag" style="color:black">Trailer</p>
            </button>
          </div>
        </div>
        <!-- <div class="col-xlg-2 col-lg-2 col-md-2 col-sm-3 buttonHover">
          <CardLikeBtn color="BLACK" container="Detail" :content="content" />
        </div> -->
        <!-- <div class="col-xlg-2 col-lg-2 col-md-2 col-sm-3 buttonHover">
          <CardDisLikeBtn color="BLACK" container="Detail" :content="content" />
        </div> -->

        <div class="col-xlg-2 col-lg-2 col-md-2 col-sm-3 buttonHover">
          <Share color="BLACK" class="card-share-btn" :content="content" />
        </div>
      </div>
    </div>
    <FormError v-show="detailError" :message="detailError"></FormError>
    <Loading v-show="showLoading"></Loading>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import App from "@/mixins/App";
import User from "@/mixins/User";
import Utility from "@/mixins/Utility";
import firebase from "firebase/app";
import "firebase/database";
import { EventBus } from "@/main";
// import undefined from "firebase/database";

export default {
  name: "Detail",
  data() {
    return {
      content: null,
      contentid: undefined,
      showLoading: false,
      showLoadingForButton: false,
      detailError: null,
      languages: null,
      purchaseDetails: null,
      progress: null,
      contentPrice: null,
      abc: false,
      buttonTitle: ''
    };
  },
  components: {
    FormError: () => import("@/components/Templates/FormError.vue"),
    Loading: () => import("@/components/Templates/Loading.vue"),
    CardDisLikeBtn: () => import("@/components/Templates/dislikeBtn.vue"),
    CardLikeBtn: () => import("@/components/Templates/likeBtn.vue"),
    Share: () => import("@/components/Slots/share.vue")
  },
  created() {
    this.CommitConfigStore();
    this.CommitUserStore();
    this.contentid = this.$route.params.id;
    // Component execution entry point when navited from
    // other page
    if (this.country) {
      //
      this.getCurrency();
      this.getContentData();
    }
    if (this.currency) {
      this.getContentCurrency();
    }
    EventBus.$on('DetailPurchase', () => {
      // console.log('detail purchased console');
      this.getTicketList();
    })
  },
  watch: {
    subscriberid() {
      if (this.subscriberid) {
        this.getTicketList();
        this.getCardProgress();
      }
    },
    // currency() {
    //   if (this.currency) {
    //     // this.getContentCurrency()
    //   }
    // }
  },
  computed: {
    ...mapGetters(["subscriberid", "vendorid", "country", "currency"])
  },
  mounted() {
    //
    this.scrollPageToTop();
  },
  methods: {
    ...mapMutations([
      "CommitUserStore",
      "CommitConfigStore",
      "commitNewTicket"
    ]),
    getContentCurrency() {
      this.contentPrice = this.getContentPrice(this.content);
    },
    ...mapActions([
      // Defined in Contents.js Store
      "actGetContent",
      "actListTicket"
    ]),
    watchTrailer() {
      EventBus.$emit("showPlayer", this.content, "T");
    },
    getCrew() {
      let castAndCrew = null;
      let castAndCrewList = [];
      if (!this.content.castncrew) return castAndCrew;
      let castArray = this.content.castncrew.filter(
        cr => cr.castncrewtype == "CAST"
      );
      let crewArray = this.content.castncrew.filter(
        cr => cr.castncrewtype == "CREW"
      );
      if (castArray.length > 0) {
        let data = {
          role: "Starring",
          names: castArray
        };
        castAndCrewList.push(data);
      }
      if (crewArray.length > 0) {
        crewArray.forEach(element => {
          let index = castAndCrewList.findIndex(
            ele => ele.role === element.castncrewrole
          );
          if (index > -1) {
            castAndCrewList[index].names.push(element);
          } else {
            let data = {
              role: element.castncrewrole,
              names: [element]
            };
            castAndCrewList.push(data);
          }
        });
      }
      castAndCrewList.forEach(ele => {
        ele.names = this.comaSeparatedNames(ele.names);
      });
      return castAndCrewList;
    },
    comaSeparatedNames(names) {
      let length = names.length;
      let nameString = "";
      for (let index = 0; index < length; index++) {
        if (nameString) {
          nameString += " , " + names[index].castncrewname;
        } else {
          nameString = names[index].castncrewname;
        }
      }
      return nameString;
    },
    routeCard(content) {
      let status = content.contentstatus;
      if (status === "INACTIVE") return;
      if (!this.subscriberid) {
        let data = {
          popup: "PaymentPopup",
          contentid: this.content.contentid
        };
        EventBus.$emit("LoginPopup", data);
      } else if (this.subscriberid && !this.purchaseDetails) {
        let data = {
          content: content
        };
        EventBus.$emit("PaymentPopup", data);
      } else if (this.subscriberid) {
        EventBus.$emit("showPlayer", this.content);
      }
    },
    // getCurrency (currency) {
    //   let str = ''
    //   switch (currency) {
    //       case "INR":
    //       str = "₹"
    //       break;
    //       default:
    //       str = "$"
    //       break;
    //   }
    //   return str
    // },
    getContentData() {
      this.showLoading = true;
      // Defined in Contents.js Store
      this.actGetContent(this.contentid)
        .then(response => {
          this.showLoading = false;

          if (response.error) {
            // console.log('Detail Error', response)
            return;
          }

          this.content = response;
          // console.log("content details", this.content);

          let contentLanguage = "";

          this.content.tags.forEach(element => {
            let str = element.includes("Lang");
            if (str) {
              let str2 = element.split("-");
              if (str2 && str2.length > 1) {
                contentLanguage = str2[1].split("|");
              }
            }
          });
          this.languages = contentLanguage;
          // check for user bought ticket
          if (this.subscriberid) {
            this.getTicketList();
            this.getCardProgress();
          }
          this.getContentCurrency();
          if (!this.subscriberid) {
            this.buttonTitle = `Purchase for ${ this.contentPrice.currencysymbol } ${ this.contentPrice.amount / 100 }`
          }
        })
        .catch(error => {
          if (error.status === 401) {
            this.sessionExpiredCB();
            this.$router.push({ name: "Login" });
          }
        });
    },
    scrollPageToTop() {
      let element = document.getElementById("Detail");
      if (!element) return;
      // Scroll to the element
      this.$scrollTo(element, 500);
    },
    getTicketList() {
      this.showLoadingForButton = true
      this.actListTicket()
        .then(response => {
          this.commitNewTicket(false);
          if (response.length > 0) {
            let index = response.findIndex(
              ele => ele.contentid === this.contentid
            );
            if (index > -1) {
              let content = response[index];
              let data = {
                currency: content.currency,
                ticketid: content.ticketid,
                ticketprice: content.ticketprice,
                created: content.created
              };
              this.content.purchaseDetails = this.purchaseDetails = data;
            }
          }
          this.showLoadingForButton = false
          if(this.purchaseDetails && this.subscriberid) {
            this.buttonTitle = "watch now"
          } else {
            this.buttonTitle = `Purchase for ${ this.contentPrice.currencysymbol } ${ this.contentPrice.amount / 100 }`   
          }
        })
        .catch(error => {
          if (error.status === 401) {
            this.sessionExpiredCB();
            EventBus.$emit("logOut");
            // window.location.reload()
            this.$router.push({ name: "Home" });
          }
        });
    },
    // Get the progress data
    getCardProgress() {
      let content = this.content;
      let contentid = content.contentid;
      let contenttype = content.contenttype;
      // Create the firebase paths to fetch the data
      let path = `${this.vendorid}/subscriber/${this.subscriberid}/content/${contentid}`;

      firebase
        .database()
        .ref(path)
        .on("value", snapshot => {
          if (snapshot.val()) {
            let response = snapshot.val();
            if (
              (response.status === "INPROGRESS" ||
                response.status === "COMPLETED") &&
              response.watchedduration > 0
            ) {
              let duration = response.duration;
              let watched = response.watchedduration;
              let progress = (watched / duration) * 100;
              if (progress > 0 && progress < 100) {
                this.progress = progress;
                this.content.progress = progress;
              }
            } else if (response.status === "COMPLETED") {
              this.progress = null;
            }
          }
        });
    }
  },
  mixins: [App, User, Utility]
};
</script>
<style lang="scss" scoped>
.content-detail-container {
  .backimg {
    float: left;
    margin-top: -5px;
    margin-right: 1%;
  }
  .title {
    color: #212121;
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 5px;
    letter-spacing: 0.74px;
    text-transform: uppercase;
    font-family: "ProximanovaBold";
  }
  .gradient-container {
    padding: 0;
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 75px;
      margin-top: -20%;
      background: linear-gradient(
        0deg,
        #ffffff 0,
        #ffffff 35%,
        rgba(255, 255, 255, 0.5),
        transparent
      );
    }
  }
  .content-container {
    padding: 2% 5%;

    h2 {
      color: #212121;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 5px;
      letter-spacing: 0.74px;
      text-transform: uppercase;
      font-family: "ProximanovaBold";
    }
    .card-detail-progress {
      width: 70%;
      height: 2px;
      background-color: rgba(167, 167, 167, 0.5);
      margin: 20px 0;
      .progress-percent {
        height: 100%;
        background-color: #4558dd;
      }
    }
    .content-tags,
    .languages {
      display: flex;
      p {
        float: left;
        color: #212121;
        opacity: 0.85;
        font-family: "ProximanovaSemibold";
        font-size: 14px;
        line-height: 24px;
        margin-right: 16px;
        text-transform: uppercase;
      }
    }
    .trailer-btn {
      img {
        width: 30px;
      }
      p {
        font-family: "ProximanovaRegular";
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
        text-align: center;
      }
    }
    .content-description {
      color: black;
      font-family: "ProximanovaRegular";
      font-size: 14px;
      line-height: 20px;
      margin: 15px 0;
      border-bottom: 0.5px solid rgba(0, 0, 0, 0.4);
      padding-bottom: 10px;
    }
    .detail-card-ioncs {
      margin: 2% 0;
      .icons {
        float: left;
        margin-right: 25px;
      }
    }
    .card-book-btn {
      button {
        margin: 5% 0;
        padding: 10px;
        // color: #000000;
        // font-family: "HelveticaNeueMedium";
        font-size: 16px;
        letter-spacing: 0.44px;
      }
    }
    .starring {
      float: left;
      margin-right: 5px;
      color: rgba(0, 0, 0, 0.5);
      font-family: "ProximanovaSemibold";
      font-size: 14px;
      line-height: 24px;
    }
    .castncrew {
      word-break: break-word;
      color: rgb(152, 152, 152);
      font-family: "ProximanovaRegular";
      font-size: 14px;
      line-height: 24px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Detail/Detail.vue